<template>
  <div class="main">
    <div class="c-nav-tabs">
      <ul class="nav-tabs">
        <li>
          <router-link to="/pc/basis">基本信息</router-link>
        </li>
        <li>
          <router-link to="/pc/account">账号信息</router-link>
        </li>
        <li class="active">
          <router-link to="/pc/password">修改密码</router-link>
        </li>
      </ul>
    </div>
    <div class="m-main-wrap navs-tab">
      <div class="c-form">
        <div class="m-area" v-for="o in list" :key="o.fieldName">
          <SText :info="o" type="password"></SText>
        </div>
        <div class="form-row t-center">
          <button
            class="form-btn save u-mr20"
            @click="save()"
            :disabled="isDisabled"
          >
            保存
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ck } from "fire-wind-water/cookie";
import { cr } from "fire-wind-water/core";
import { md5 } from "fire-wind-water/md5";
import { createField, updateDirty } from "../../common/sbase";
import { sess } from "../../common/sbase";
import member from "../../services/member";
import { PASSWORD } from "../../common/setting";

export default {
  name: "Password",
  data() {
    return {
      list: [],
      listSetting: PASSWORD,
      od: null,
      nd: null,
      cd: null,
      isDisabled: false,
      isMessageShow: false
    };
  },
  methods: {
    initList() {
      window.$sk.loading.hide();
      this.list = [];
      cr.each(this.listSetting, d => {
        const item = createField(d);
        if (item.fieldName === "oldPwd") {
          this.od = item;
        }
        if (item.fieldName === "newPwd") {
          this.newPwdCustomError(item);
          this.nd = item;
        }
        if (item.fieldName === "confirmPwd") {
          this.confirmPwdCustomError(item);
          this.cd = item;
        }
        if (item) {
          this.list.push(item);
        }
      });
    },
    newPwdCustomError(np) {
      np.setCustomError({
        key: "confirm",
        value: false,
        message: "",
        validator: e => {
          return this.newPwd(e);
        }
      });
    },
    newPwd() {
      this.cd.hasError();
      return true;
    },
    confirmPwdCustomError(item) {
      item.setCustomError({
        key: "confirm",
        value: false,
        message: "两次输入密码不一致",
        validator: e => {
          return this.confirmPwd(e);
        }
      });
    },
    confirmPwd(s) {
      if (this.nd.value && this.nd.value !== s.value) {
        return false;
      }
      return true;
    },
    setValue() {
      cr.each(this.list, d => {
        d.initValue(null);
      });
    },
    save() {
      let isVer = updateDirty(this.list);
      if (isVer.isVerify) {
        this.isDisabled = true;
        let url = window.location.href.split("#")[0];
        const info = {
          oldPwd: md5.createHash(this.od.value).toLocaleUpperCase(),
          newPwd: md5.createHash(this.nd.value).toLocaleUpperCase(),
          confirmPwd: md5.createHash(this.cd.value).toLocaleUpperCase(),
          globalUserId: decodeURIComponent(ck.cookie("globalUserId")).replaceAll('"', ''),
          sess: sess,
          url: url
        };
        member.changePwd(info).subscribe(data => {
          this.isDisabled = false;
          if (data.result == "0") {
            this.setValue();
            this.$message.success("修改成功");
          } else {
            if (/旧密码不正确/g.test(data.desc)) {
              this.od.invalid = true;
              this.od.validationMessage = data.desc;
              return;
            }
            if (!this.isMessageShow) {
              this.isMessageShow = true;
              this.$message.error(data.desc, 3, () => {
                this.isMessageShow = false;
              });
            }
          }
        });
      }
    }
  },
  created() {
    this.initList();
  }
};
</script>

<style scoped></style>
